import { QuestionBase } from './question-base.model';

export class HiddenQuestion extends QuestionBase<string> {
   controlType = 'hidden';
   objectData: boolean;
   index: number;
   type: any;
   fire_dependent: any;
   calculated_field_type: string;
   calculation_formula: any;
   select_defination: any;
   
   constructor(options: {} = {}) {
      super(options);
      this.objectData = options['objectData'] || false;
      this.index = options['index'];
      this.type = options['type'] || 'string';
      this.fire_dependent = options['fire_dependent'];
      this.calculated_field_type = options['calculated_field_type'] || '';
      this.calculation_formula = options['calculation_formula'];
      this.select_defination = options['select_defination'] || '';

   }
}
